import noScroll from "@/utils/noScroll.js";

// Всплывающая форма «Оставить заявку». Живёт на странице всегда,
// открывается по кастомному window-событию (по умолчанию "openRequestPopup"),
// закрывается по клику на фон, кнопке закрытия и Escape.
export default function requestPopup(element, data) {
    const openEvent = data.openEvent || "openRequestPopup";
    const closeEvent = data.closeEvent || "closeRequestPopup";
    const className = data.class || "open";
    const closeSelector = data.closeSelector || "[data-popup-close]";

    let isOpen = false;

    function open() {
        if (isOpen) {
            return;
        }
        isOpen = true;
        element.classList.add(className);
        noScroll.hideScroll();
    }

    function close() {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        element.classList.remove(className);
        noScroll.showScroll();
    }

    window.addEventListener(openEvent, open);
    window.addEventListener(closeEvent, close);

    // Клик по затемнённому фону (мимо окна) или по кнопке закрытия
    element.addEventListener("click", function (event) {
        if (event.target === element || event.target.closest(closeSelector)) {
            close();
        }
    });

    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            close();
        }
    });
}
